/* Card de produto no celular (Guga, 31/10):
   - toque em qualquer ponto da parte de baixo (nome, nota, preço) abre o produto;
   - toque na foto abre o produto; segurar o dedo na foto mostra a 2ª foto (soltou, volta) e não abre. */
(function () {
  if (window.altoCardTouch) return;
  window.altoCardTouch = true;
  var HOLD = 350, MOVE = 10;
  var cardUrl = function (card) {
    var a = card && card.querySelector('.product-card__figure a[href], .product-card__title a[href], a[href*="/products/"]');
    return a ? a.href : null;
  };
  var suppressUntil = 0;
  document.addEventListener('click', function (e) {
    if (Date.now() < suppressUntil && e.target.closest('.product-card__figure')) {
      e.preventDefault(); e.stopPropagation(); return;
    }
    var info = e.target.closest('.product-card__info');
    if (!info) return;
    if (e.target.closest('a, button, input, label, select, textarea, [role="button"], form, summary')) return;
    var u = cardUrl(info.closest('product-card, .product-card'));
    if (!u) return;
    if (e.metaKey || e.ctrlKey) { window.open(u, '_blank'); return; }
    window.location.href = u;
  }, true);

  var timer = null, fig = null, sx = 0, sy = 0, peeked = false;
  var stop = function () { clearTimeout(timer); timer = null; };
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) return;
    var f = e.target.closest('.product-card--show-secondary-media .product-card__figure');
    if (!f) return;
    fig = f; peeked = false; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    stop();
    timer = setTimeout(function () { peeked = true; fig.classList.add('is-peek'); }, HOLD);
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!fig || !timer) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - sx) > MOVE || Math.abs(t.clientY - sy) > MOVE) stop();
  }, { passive: true });
  var end = function () {
    stop();
    if (fig && peeked) { suppressUntil = Date.now() + 700; fig.classList.remove('is-peek'); }
    fig = null; peeked = false;
  };
  document.addEventListener('touchend', end, { passive: true });
  document.addEventListener('touchcancel', end, { passive: true });
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest('.product-card__figure')) e.preventDefault();
  });
})();

/* Links dos kits sem UTM (Guga, 31/10: "tem que tirar a UTM do link de kit"). Um script de rastreio cola
   utm_source=direto&sck=direto em todo link interno; nos links de kit isso é limpo, e também os parâmetros do
   modo revisão (preview_theme_id, _eab). O resto do site segue com o rastreio como está. */
(function () {
  if (window.altoKitLinksClean) return;
  window.altoKitLinksClean = true;
  var DROP = /^(utm_[a-z]+|sck|src|preview_theme_id|_eab|_pos|_sid|_ss|_psq|_v|fbclid|gclid)$/i;
  var isKit = function (href) { return /\/pages\/kit-|[?&]view=kit-|kits-black-november/.test(href || ''); };
  var clean = function (a) {
    var href = a.getAttribute('href');
    if (!isKit(href)) return;
    try {
      var u = new URL(href, location.origin);
      var keys = []; u.searchParams.forEach(function (v, k) { if (DROP.test(k)) keys.push(k); });
      if (!keys.length) return;
      keys.forEach(function (k) { u.searchParams.delete(k); });
      var out = u.pathname + (u.search || '') + u.hash;
      if (out !== href) a.setAttribute('href', out);
    } catch (e) {}
  };
  var sweep = function (root) { (root.querySelectorAll ? root : document).querySelectorAll('a[href]').forEach(clean); };
  var start = function () {
    sweep(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'attributes' && m.target.tagName === 'A') clean(m.target);
        else m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'A') clean(n); else sweep(n); } });
      });
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
  };
  // na hora do clique, limpa de novo (caso algum script mexa no link no último instante)
  ['pointerdown', 'click'].forEach(function (t) {
    document.addEventListener(t, function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a) clean(a); }, true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
